import { IRankingRepository } from '../../domain/repositories/IRankingRepository';
import { StudentRankingDTO } from '../dto/RankingDTO';
import { RankingMapper } from '../mappers/RankingMapper';

export class GetStudentRankingUseCase {
  constructor(private readonly repository: IRankingRepository) {}

  async execute(studentId: string): Promise<StudentRankingDTO | null> {
    const ranking = await this.repository.getStudentRanking(studentId);

    if (!ranking) {
      // Try to ensure participation and get ranking again
      try {
        await this.repository.ensureStudentParticipation(studentId);
        const newRanking = await this.repository.getStudentRanking(studentId);
        if (!newRanking) return null;

        // Get total members for promotion status calculation
        const leaderboard = await this.repository.getLeaderboard({
          leagueId: newRanking.leagueId,
          weeklyCycleId: newRanking.toPlainObject().weeklyCycleId,
          currentUserId: studentId,
        });

        return RankingMapper.toStudentRankingDTO(newRanking, leaderboard.length);
      } catch (error) {
        console.error('Error ensuring participation:', error);
        return null;
      }
    }

    // Get total members for promotion status calculation
    const leaderboard = await this.repository.getLeaderboard({
      leagueId: ranking.leagueId,
      weeklyCycleId: ranking.toPlainObject().weeklyCycleId,
      currentUserId: studentId,
    });

    return RankingMapper.toStudentRankingDTO(ranking, leaderboard.length);
  }
}
